export const getCanAccessCookieValue = (cookieName: string) => {
  if (typeof window === 'undefined') {
    return false;
  }

  const cookies = document.cookie.split('; ');

  return cookies.some((cookie) => {
    if (cookie.includes(cookieName) && cookie.split('=')?.[1] === 'true') {
      return true;
    }

    return false;
  });
};
